const AISignificanceIcon = ({ ...props }) => {
	return (
		<svg
			{...props}
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_1_22276)">
				<path
					d="M1 8.02893C1.19721 -0.999747 13.2934 -1.50354 14.0548 7.52257C14.3965 17.1187 1.37221 17.6824 1 8.02893ZM2.17069 8.11225C2.40746 15.471 12.4514 15.6894 12.8999 8.31718C13.11 0.437635 2.31642 0.11432 2.17069 8.11225Z"
					fill="currentColor"
				/>
				<path
					d="M11.7078 8.13221C11.4626 13.9773 3.38748 13.8312 3.39649 7.93565C3.58437 1.99567 11.6843 2.15105 11.7078 8.13221ZM10.5339 8.12642C10.7089 5.4524 7.49213 3.64023 5.54195 5.6065C4.25384 6.89043 4.22102 9.005 5.46892 10.3272C7.30651 12.3668 10.6101 10.6473 10.5339 8.12642Z"
					fill="currentColor"
				/>
				<path
					d="M9.32421 8.04054C9.34866 9.53294 7.50335 10.5859 6.36291 9.43192C5.52969 8.61961 5.58888 7.20411 6.48741 6.46418C7.66678 5.47462 9.3863 6.56456 9.32421 8.04054ZM8.14773 8.01095C8.16285 7.15714 6.9497 7.14266 6.94133 7.98875C6.92106 8.85446 8.14644 8.86733 8.14773 8.01095Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1_22276">
					<rect
						width="13.0616"
						height="14"
						fill="currentColor"
						transform="translate(1 1)"
					/>
				</clipPath>
			</defs>
		</svg>
	)
}

export default AISignificanceIcon
